import { render, staticRenderFns } from "./alipay-check.vue?vue&type=template&id=4f5387f3"
import script from "./alipay-check.vue?vue&type=script&lang=js"
export * from "./alipay-check.vue?vue&type=script&lang=js"
import style0 from "./alipay-check.vue?vue&type=style&index=0&id=4f5387f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports